import { render, staticRenderFns } from "./Lgx243090021777670144.vue?vue&type=template&id=c5afe79a&scoped=true&"
import script from "./Lgx243090021777670144.vue?vue&type=script&lang=js&"
export * from "./Lgx243090021777670144.vue?vue&type=script&lang=js&"
import style0 from "./Lgx243090021777670144.vue?vue&type=style&index=0&id=c5afe79a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5afe79a",
  null
  
)

export default component.exports